import type Phaser from 'phaser';

export type LanguageCode = 'es' | 'en';

const STORAGE_KEY = 'imbasion_lang';

let currentLanguage: LanguageCode = 'es';
let dictionaries: Record<LanguageCode, Record<string, string>> = {
  es: {},
  en: {},
};

let initialized = false;

function safeGetStorage(): Storage | null {
  try {
    if (typeof window === 'undefined') return null;
    return window.localStorage ?? null;
  } catch {
    return null;
  }
}

export function initLocalization(scene: Phaser.Scene): void {
  const es = scene.cache.json.get('i18n-es') as Record<string, string> | undefined;
  const en = scene.cache.json.get('i18n-en') as Record<string, string> | undefined;

  if (es) dictionaries.es = es;
  if (en) dictionaries.en = en;

  const storage = safeGetStorage();
  const stored = storage?.getItem(STORAGE_KEY);
  if (stored === 'es' || stored === 'en') {
    currentLanguage = stored;
  }

  initialized = true;
}

export function getLanguage(): LanguageCode {
  return currentLanguage;
}

export function setLanguage(lang: LanguageCode): void {
  currentLanguage = lang;
  const storage = safeGetStorage();
  storage?.setItem(STORAGE_KEY, lang);
}

export function t(key: string): string {
  if (!initialized) {
    // Fallback seguro si aún no se llamó initLocalization()
    return key;
  }

  return (
    dictionaries[currentLanguage]?.[key] ??
    dictionaries.es?.[key] ??
    key
  );
}
